import { connect } from 'react-redux';
import { getExternalData } from '../../../../../../core/slices/annualPlanV2';
import { uploadChecklistAnswerEvidenceAction } from '@/core/slices/checklists';
import {
  createAnnualPlan,
  setCurrentVersion,
  setApYear,
  updateAnnualPlan,
  setCurrentPlanId,
  setSelectedHierarchicalModel,
  setCreatingOutOfTimePlan,
  savePlanRequirementDecisions,
  fetchAnnualPlanStep0Context,
} from '../../../../../../core/slices/plans';
import {
  annualPlanExternalData,
  currentVersion,
  isLoadingAnnualPlans,
  annualPlanV2ErrorMessage,
  selectedYear,
  scopeName,
  currentPlanId,
  currentBusinessUnit,
  selectedHierarchicalModelId,
  creatingOutOfTimePlan,
  activeOutOfTimeRequestId,
  requirements,
  planRequirementDecisions,
  readOnlyMode,
} from '../../../../../../core/selectors';
import { RootState } from '../../../../../../core/types/state';
import NewAnnualPlan from '../../../../components/AnnualPlanning/FirstTerm/NewAnnualPlan';

const ConnectedNewAnnualPlan = connect(
  (state: RootState) => ({
    externalData: annualPlanExternalData(state),
    currentVersion: currentVersion(state),
    isLoading: isLoadingAnnualPlans(state),
    errorMessage: annualPlanV2ErrorMessage(state),
    selectedYear: selectedYear(state),
    scopeName: scopeName(state),
    currentPlanId: currentPlanId(state),
    currentBusinessUnit: currentBusinessUnit(state),
    selectedHierarchicalModelId: selectedHierarchicalModelId(state),
    creatingOutOfTimePlan: creatingOutOfTimePlan(state),
    outOfTimeRequestId: activeOutOfTimeRequestId(state),
    requirements: requirements(state),
    planRequirementDecisions: planRequirementDecisions(state),
    readOnlyMode: readOnlyMode(state),
  }),
  {
    createAnnualPlan,
    getExternalData,
    setCurrentVersion,
    setApYear,
    updateAnnualPlan,
    setCurrentPlanId,
    setSelectedHierarchicalModel,
    setCreatingOutOfTimePlan,
    savePlanRequirementDecisions,
    fetchAnnualPlanStep0Context,
    uploadPlanRequirementEvidence: uploadChecklistAnswerEvidenceAction,
  },
)(NewAnnualPlan);

export default ConnectedNewAnnualPlan;
